import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './PublicationSection.css';
import {DEFAULT_COLOR} from '../../../globalVariables/GlobalVariables';
import {useField} from 'formik';
import CheckboxFormik from '../../checkboxFormik/CheckboxFormik';
import ImagePopup from '../../imagePopup/ImagePopup';
import {useSelector} from 'react-redux';

const PublicationSection = () => {
    const {t} = useTranslation('event');
    const type = useSelector((state: any) => state.event.type);
    const [{value: showInLive}] = useField('showInLive');
    const [{value: tickchakIndex}] = useField('tickchakIndex');
    const [{value: glatticketIndex}] = useField('glatticketIndex');
    const [{value: privateEvent}] = useField('privateEvent');
    const [{value: image},,imageHelpers] = useField('mobileImage.image');

    const promotionItems = [
        ...(type !== 'givechak' ? [{
            key: 'tickchakLive',
            translationKey: 'publishInTickchakLive',
            color: DEFAULT_COLOR,
            setting: 'showInLive',
            value: showInLive
        }] : []),
        {
            key: type === 'givechak' ? 'givechak' : 'tickchak',
            translationKey: type === 'givechak' ? 'publishInGivechak' : 'publishInTickchak',
            setting: 'tickchakIndex',
            value: tickchakIndex
        },
        ...(type !== 'givechak' ? [{
            key: 'glatticket',
            translationKey: 'publishInGlatticket',
            setting: 'glatticketIndex',
            value: glatticketIndex
        }] : [])
    ];

    return (
        <>
            <css.promotionSection>
                <css.promotionRight>
                    <css.wrap>
                        <css.sectionTitle>{t('promotionAndDistribution')}</css.sectionTitle>
                        <css.sectionSubtitle>{t('chooseWhereToPublish')}</css.sectionSubtitle>
                    </css.wrap>
                    <css.wrap>
                        {promotionItems.map(item => (
                            <css.checklistItem key={item.key}>
                                <CheckboxFormik
                                    name={item.setting}
                                    text={t(item.translationKey)}
                                    color={undefined}
                                    disabled={!!privateEvent}
                                />
                            </css.checklistItem>
                        ))}
                    </css.wrap>
                </css.promotionRight>
                {/* Promotion Image */}
                <css.promotionLeft>
                    <css.sectionTitle>{t('imageForDistribution')}</css.sectionTitle>
                    <css.sectionSubtitle>{t('imageDimensions')}</css.sectionSubtitle>
                </css.promotionLeft>
                <css.imagePopupWrapper>
                    <ImagePopup
                        imageProps={{
                            size: {height: 210, width: 150},
                            image: image,
                            imageId: '',
                            setImage: imageHelpers.setValue,
                        }}
                        fieldName={'mobileImage'}
                    />
                </css.imagePopupWrapper>
            </css.promotionSection>
        </>
    );
};

export default PublicationSection;
